(() => {
  let pending = Promise.resolve();
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!form.matches('.eny-ajax-cart-form')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';
    const button = form.querySelector('[name="add"]');
    const status = form.querySelector('.eny-cart-status');
    const label = button.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    const add = async () => {
      let added = false;
      try {
        const root = window.Shopify.routes.root;
        const sections = [...document.querySelectorAll('page-header, cart-drawer')].filter(el => el.dataset.sectionId);
        const body = new FormData(form);
        body.delete('return_to');
        body.set('sections', sections.map(el => el.dataset.sectionId).join(','));
        body.set('sections_url', window.location.pathname);
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {Accept: 'application/json'}, body});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : button.dataset.errorLabel);
        added = true;
        button.textContent = button.dataset.addedLabel;
        status.textContent = button.dataset.addedLabel;
        for (const section of sections) {
          const html = data.sections?.[section.dataset.sectionId];
          if (!html) continue;
          if (section.matches('page-header')) {
            section.updateFromCartChange(html);
          } else {
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const fresh = parsed.querySelector('cart-form');
            const current = section.querySelector('cart-form');
            if (fresh && current) current.replaceWith(fresh);
          }
        }
        const cartResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}});
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          document.querySelectorAll('.cart-link__count').forEach(el => { el.textContent = cart.item_count || ''; });
        }
        form.dispatchEvent(new CustomEvent('on:cart:add', {bubbles: true, detail: {variantId: data.variant_id}}));
      } catch (error) {
        if (!added) status.textContent = error.message || button.dataset.errorLabel;
      } finally {
        button.removeAttribute('aria-busy');
        window.setTimeout(() => {
          button.textContent = label;
          button.disabled = false;
          delete form.dataset.busy;
        }, added ? 1600 : 0);
      }
    };
    pending = pending.then(add, add);
  });
})();